<div class="pt-5 pb-5 fs-6 mt-inter bg-black mt-4">
    <div class="container mt-3 mb-3">
        <div class="row">
            <div class="col-lg-4">
                <h3 class="text-white mb-3">
                    <a [routerLink]="['/']" class="text-white text-decoration-none">
                        {{sitename()}}
                    </a>
                </h3>
                <div class="inter fw-normal text-white fs-6 mb-3">{{tagline()}}</div>
                <div class="inter text-secondary fw-normal fs-6 lh-lg mt-5 pe-5">{{address()}}</div> 
            </div>
            <div class="col-lg-2">
                <h3 class="fs-6 fw-medium text-white mb-3">Get in touch</h3>
                <ul class="list-unstyled inter">
                    <li class="py-3 text-secondary">
                        <a href="https://www.facebook.com/bewellcsodiumascorbate/" class="text-decoration-none text-secondary" target="_blank">Facebook</a>
                    </li>
                    <li class="py-3 text-secondary">
                        <a href="https://www.tiktok.com/@bewell_shop" target="_blank" class="text-decoration-none text-secondary">Tiktok</a>
                    </li>
                    <li class="py-3 text-secondary">
                        <a href="javascript:void(0)" [routerLink]="['/contacts']" class="text-decoration-none text-secondary">Contact Us</a>
                    </li>
                </ul>
            </div>
            <div class="col-lg-2">
                <h3 class="fs-6 fw-medium text-white mb-3">Company</h3>
                <ul class="list-unstyled inter">
                    <li class="py-3 text-secondary">
                        <a href="javascript:void(0)" [routerLink]="['/products']" class="text-decoration-none text-secondary">Products</a>
                    </li>
                    <li class="py-3 text-secondary">
                        <a href="javascript:void(0)" [routerLink]="['/careers']" class="text-decoration-none text-secondary">Careers</a>
                    </li>
                    <li class="py-3 text-secondary"><a class="text-decoration-none text-secondary" href="https://shop.bewell.com.ph">Shop</a></li>
                </ul>
            </div>
            <div class="col-lg-2">
                <h3 class="fs-6 fw-medium text-white mb-3">Sales</h3>
                <ul class="list-unstyled inter">
                    <li class="py-3 text-secondary">341-14-308 (221)</li>
                    <li class="py-3 text-secondary">0995-774-4124</li>
                    <li class="py-3 text-secondary">nsm@bewell.com.ph</li>
                </ul>
            </div>
            <div class="col-lg-2">
                <h3 class="fs-6 fw-medium text-white mb-3">Marketing</h3>
                <ul class="list-unstyled inter">
                    <li class="py-3 text-secondary">341-14-308 (224)</li>
                    <li class="py-3 text-secondary">0966-851-5639</li>
                    <li class="py-3 text-secondary">dmo@bewell.com.ph</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<div class="bg-black sub-footer">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="pt-4 pb-2">
                    <ul class="list-unstyled list-inline inter fs-8 text-secondary">
                        <li class="list-inline-item pe-2">
                            <a href="javascript:void(0)" class="text-decoration-none text-secondary" [routerLink]="['/']">&copy; {{sitename()}}</a>
                        </li>
                        <li class="list-inline-item">All rights reserved {{today | date:'yyyy' : timezone}}</li>
                        <li class="list-inline-item px-3">
                            <a href="javascript:void(0)" class="text-decoration-none text-secondary" [routerLink]="['/privacy-policy']">Privacy Policy</a>
                        </li>
                        <li class="list-inline-item px-3">
                            <a href="https://bewell.com.ph/sitemap.xml" class="text-decoration-none text-secondary">Sitemaps</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>